exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-box[data-v-73237533] {\n  width: 20px;\n  height: 20px;\n  border-radius: 3px;\n}\n.yellow[data-v-73237533] {\n  background: #f6bf26;\n}\n.orange[data-v-73237533] {\n  background: #f4511e;\n}\n.red[data-v-73237533] {\n  background: #d50000;\n}\n.violet[data-v-73237533] {\n  background: #7986cb;\n}\n.blue[data-v-73237533] {\n  background: #039be5;\n}\n.green[data-v-73237533] {\n  background: #4caf50;\n}\n.align-center[data-v-73237533] {\n  text-align: center;\n}\n", ""]);

// exports
